<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <!--<el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>-->
            <el-breadcrumb-item>组织管理</el-breadcrumb-item>
        </el-breadcrumb>

        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding: 20px 0px;text-align: left" >
            <el-form :inline="true" :model="topForm" ref="topForm">

                <el-form-item prop="name">
                    <el-input v-model="topForm.orgName" placeholder="组织机构名称" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="getData()" icon="search":loading="loading" >查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="add()"  >新增</el-button>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="resetForm('topForm')" >重置</el-button>
                </el-form-item>

            </el-form>
        </el-col>

        <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="org_name" label="组织机构名称"></el-table-column>
            <el-table-column  prop="org_level" label="组织机构级别"></el-table-column>
            <el-table-column prop="pname" label="上级组织机构"></el-table-column>
            <el-table-column prop="tenant_name" label="所属租户"></el-table-column>
            <el-table-column prop="update_time" label="修改日期" :formatter="updateformatter"></el-table-column>、
            <el-table-column label="操作" width="350" >
                <template scope="scope" >
                    <el-button  size="small" @click="modify(scope.row)">编辑</el-button>
                    <el-button  size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                    <el-button  size="small" type="info" @click="addRoles(scope.row)">绑定登录账户</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="block">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-chahange="handleSizeChange"
                    :current-page="currentpage"
                    :page-count="pagesCount"
                    :page-sizes="pagesizes"
                    :page-size="pagesize"
                    :total="pagesCount"
                    layout=" total, prev, pager, next, jumper"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import moment  from 'moment'

    export default {
        data() {
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                loading:false,
                tableData: [],
                topForm:{
                    orgName:'',
                }
            }
        },
        created(){
            this.getData();
        },
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pagesize = val
                this.activeNum = (val * this.currentpage) - val;
                this.endNum = (val * this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val) {
                this.currentpage = val;
                this.activeNum = (this.pagesize * val) - this.pagesize
                this.endNum = (this.pagesize * val)
                this.getData();
            },
            resetForm(formName) {
                this.topForm.orgName = '';
                this.getData();
            },
            getData(){
                var params = {orgName:this.topForm.orgName,orgId:'0',
                    tenantId:this.getcookie('storeId'),active:this.activeNum,len:this.pagesize};
                //异步请求
                this.$http.post(this.requetHost+"/sys/org/findOrgList",params)
                    .then(response => {
                        this.isorgsubmit = false;
                        if (response.status === 200) {
                            if(response.body.Code == '200'){
                                this.tableData = response.body.Data.orgList;
                                this.pagesCount = response.body.Data.count;

                            }else {
                                this.$message({showClose: true,message: '查询错误',type: 'error'});
                            }

                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            add(){
                this.$router.push( {path:"orgAdd"});
            },
            modify(row){
                this.$router.push( {path:"orgModify",query:{row:row}});
            },
            updateformatter(row, column) {
                console.log()
                var d = new Date(row.update_time.time)
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            handleDelete(row) {
                this.$confirm('你确定要删除这条数据么？删除是不可恢复的', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var params = {orgId:row.org_id,tenantId:this.getcookie('storeId')};
                    //异步请求
                    this.$http.post(this.requetHost+"/sys/org/delOrg",params)
                        .then(response => {
                            this.isorgsubmit = false;
                            if (response.status === 200) {
                                if(response.body.Code == '202'){
                                    this.$message({showClose: true,message: '该机构存在下属机构，不允许删除',type: 'error'});
                                }else if(response.body.Code == '203'){
                                    this.$message({showClose: true,message: '该机构正在被用户，不允许删除',type: 'error'});
                                }else if(response.body.Code == '200'){
                                    this.$message({showClose: true,message: '删除成功',type: 'success'});
                                    this.getData();
                                }else {
                                    this.$message({showClose: true,message: '删除失败',type: 'error'});
                                }

                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                })
            },
            addRoles(row){
                this.$router.push( {name:"orgUser",params:{row:row}})
            },
        }
    }
</script>


// WEBPACK FOOTER //
// OrgManager.vue?786e41a6